import PropTypes from "prop-types";

import MaterialFieldPreview from "@/components/Elements/FieldPreview/MaterialFieldPreview";
import { useGetObservationMaterialInfos } from "@/entities/observation";

export const TableCellMaterialInfo = ({ observation, field }) => {
  const { isLoading, ...info } = useGetObservationMaterialInfos(observation);

  return <MaterialFieldPreview value={info[field]} loading={isLoading} />;
};

TableCellMaterialInfo.propTypes = {
  observation: PropTypes.object.isRequired,
  field: PropTypes.oneOf(["material", "defect"]).isRequired,
};
